import React, { useState, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { G_API } from '../constants/globalVar';

const SubscriptionForm = () => {
  const recaptchaRef = useRef(null);
  const [captchaToken, setCaptchaToken] = useState(null);
  
  const [formData, setFormData] = useState({
    name: '',
    email: ''
  });
  const [status, setStatus] = useState({
    loading: false,
    success: null,
    error: null
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const handleCaptchaExpired = () => {
    setCaptchaToken(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaToken) {
      setStatus({
        loading: false,
        success: null,
        error: 'Please complete the reCAPTCHA verification.'
      });
      return;
    }

    setStatus({ loading: true, success: null, error: null });

    try {
      const response = await fetch(`${G_API}usersubscriptions/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          captchaToken: captchaToken 
        }),
      });

      const result = await response.json();

      if (response.ok && result.success) {
        setStatus({
          loading: false,
          success: 'Thank you for subscribing!',
          error: null
        });

        setFormData({ name: '', email: '' });
        setCaptchaToken(null);
        recaptchaRef.current.reset();
      } else {
        throw new Error(result.message || 'Something went wrong.');
      }
    } catch (err) {
      setStatus({
        loading: false,
        success: null,
        error: err.message || 'Failed to connect to the server.'
      });
    }
  };

  return (
    <div className="container mt-5" style={{ maxWidth: '500px' }}>
      <div className="card shadow-sm p-4">
        <h2 className="card-title text-center mb-4">Subscribe Now</h2>
        
        {/* Status Alerts */}
        {status.success && (
          <div className="alert alert-success" role="alert">
            {status.success}
          </div>
        )}
        {status.error && (
          <div className="alert alert-danger" role="alert">
            {status.error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          {/* Name Field */}
          <div className="mb-3">
            <label htmlFor="name" className="form-label">Name</label>
            <input
              type="text"
              className="form-control"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="John Doe"
              required
            />
          </div>

          {/* Email Field */}
          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email address</label>
            <input
              type="email"
              className="form-control"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="name@example.com"
              required
            />
          </div>

          {/* reCAPTCHA Widget */}
          <div className="mb-3 d-flex justify-content-center">
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey="6Lej2FQsAAAAAHAKsC2kCeU1DAOOXGfFpp0lp2Xr"
              onChange={handleCaptchaChange}
              onExpired={handleCaptchaExpired}
            />
          </div>

          {/* Submit Button */}
          <button 
            type="submit" 
            className="btn btn-primary w-100" 
            disabled={status.loading}
          >
            {status.loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Subscribing...
              </>
            ) : (
              'Subscribe'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SubscriptionForm;